export const services = {
  // Airport Transfers
  airportTransfers: 'نقل المطارات',
  airportTransfersDesc: 'خدمة نقل مميزة من وإلى جميع مطارات المغرب وكندا.',
  airportTransfersFeatures: [
    'دقة مضمونة',
    'مركبات مكيفة',
    'سائقون محترفون'
  ],
  airportTransfersDetailDesc: 'تضمن لك خدمة نقل المطار رحلة مريحة وخالية من التوتر. يرحب بك سائقونا المحترفون بلوحة اسمية ويعتنون بأمتعتك.',
  airportTransfersIncluded: [
    'تتبع الرحلات في الوقت الفعلي',
    'مركبات مرسيدس وبي إم دبليو حديثة',
    'مياه ومرطبات على متن الطائرة',
    'واي فاي مجاني في جميع المركبات',
    'خدمة الكونسيرج',
    'مساعدة على مدار الساعة'
  ],
  airports: ['محمد الخامس - الدار البيضاء', 'مراكش المنارة', 'أكادير المسيرة', 'فاس سايس', 'مونتريال-ترودو', 'تورونتو بيرسون'],
  
  // Tourist Circuits
  touristCircuits: 'الدوائر السياحية',
  touristCircuitsDesc: 'استكشف عجائب المغرب مع دوائرنا المخصصة والمرشدين الخبراء.',
  touristCircuitsFeatures: [
    'مسارات مصممة خصيصاً',
    'مرشدون متعددو اللغات',
    'اكتشافات أصيلة'
  ],
  touristCircuitsDetailDesc: 'اكتشف المغرب الأصيل مع دوائرنا المصممة خصيصاً. من مدينة فاس إلى كثبان مرزوقة، كل مسار مصمم لتقديم تجربة لا تُنسى.',
  touristCircuitsIncluded: [
    'مرشد معتمد متعدد اللغات',
    'مركبة رباعية الدفع مكيفة',
    'إقامة في الرياض والمخيمات البربرية',
    'وجبات تقليدية مشمولة',
    'أنشطة ثقافية',
    'صور احترافية'
  ],
  destinations: ['صحراء مرزوقة', 'وادي دادس', 'آيت بن حدو', 'شفشاون', 'الصويرة', 'جبال الأطلس'],
  
  // Crew Transport
  crewTransport: 'خدمة نقل أطقم الطيران',
  crewTransportDesc: 'خدمة متخصصة لطاقم المقصورة وموظفي الطيران.',
  crewTransportFeatures: [
    'نقل طاقم المقصورة',
    'مواعيد مرنة',
    'خدمة احترافية'
  ],
  crewTransportDetailDesc: 'تستهدف خدمتنا المتخصصة طاقم المقصورة وموظفي الطيران. نحن نفهم القيود الزمنية والاحتياجات المحددة لقطاع الطيران.',
  crewTransportIncluded: [
    'نقل متكيف مع مواعيد الرحلات',
    'مركبات مريحة للراحة',
    'خدمة على مدار الساعة لجميع الأوقات',
    'سائقون مدربون لاحتياجات طاقم المقصورة',
    'تتبع مواعيد الرحلات في الوقت الفعلي',
    'أسعار تفضيلية لشركات الطيران'
  ],
  occasions: ['أطقم في توقف', 'موظفو الطيران', 'طاقم المقصورة في راحة', 'نقل فندق-مطار', 'خدمات شركات الطيران'],
  
  // Day Excursions
  dayExcursions: 'رحلات يومية',
  dayExcursionsDesc: 'اكتشف المواقع الأيقونية خلال رحلات يومية لا تُنسى.',
  dayExcursionsFeatures: [
    'مغادرة مبكرة',
    'مواقع لا بد من زيارتها',
    'عودة مريحة'
  ],
  dayExcursionsDetailDesc: 'مثالي لاكتشاف كنوز المغرب في يوم واحد. تجمع رحلاتنا بين المواقع التاريخية والمناظر الطبيعية والتجارب الثقافية الأصيلة.',
  dayExcursionsIncluded: [
    'نقل ذهاب وإياب',
    'مرشد محلي ذو خبرة',
    'غداء تقليدي',
    'دخول المواقع السياحية',
    'استراحة شاي بالنعناع',
    'وقت حر للتسوق'
  ],
  dayDestinations: ['شلالات أوزود', 'وادي أوريكا', 'الصويرة', 'آيت بن حدو', 'إمليل', 'ورزازات'],
  
  // Chauffeur Service
  chauffeurService: 'تأجير مع سائق',
  chauffeurServiceDesc: 'مركبات مميزة مع سائقين ذوي خبرة لتنقلاتك الحرة.',
  chauffeurServiceFeatures: [
    'مرونة كاملة',
    'أسعار شفافة',
    'توفر على مدار الساعة'
  ],
  chauffeurServiceDetailDesc: 'استأجر مركبة مع سائق للحرية الكاملة في تنقلاتك. مثالي للإقامات الطويلة أو رحلات العمل.',
  chauffeurServiceIncluded: [
    'مركبة حديثة ومُصانة',
    'سائق محترف ثنائي اللغة',
    'وقود مشمول',
    'تأمين شامل',
    'مساعدة على الطريق على مدار الساعة',
    'تنظيف يومي للمركبة'
  ],
  vehicles: ['سيدان مريحة', 'سيارات دفع رباعي 7 مقاعد', 'حافلات صغيرة 15 مقعد', 'مركبات فاخرة'],
  
  // Canada Services
  canadaServices: 'خدمات كندا',
  canadaServicesDesc: 'امتداد خدماتنا المميزة إلى كندا لرحلاتك في أمريكا الشمالية.',
  canadaServicesFeatures: [
    'مونتريال وتورونتو',
    'دوائر شتوية',
    'تجربة كندية'
  ],
  canadaServicesDetailDesc: 'اكتشف كندا بنفس مستوى الخدمة المميزة. يقدم لك شركاؤنا المحليون تجربة أصيلة في أجمل المدن الكندية.',
  canadaServicesIncluded: [
    'مركبات متكيفة مع المناخ الكندي',
    'مرشدون ناطقون بالفرنسية',
    'دوائر حضرية وطبيعية',
    'تجارب شتوية فريدة',
    'إقامة في فنادق بوتيك',
    'تخصصات طهي محلية'
  ],
  cities: ['مونتريال', 'تورونتو', 'كيبيك', 'أوتاوا', 'شلالات نياجرا', 'مون-تريمبلان']
};